import { render, staticRenderFns } from "./asignacionAGestores.vue?vue&type=template&id=a69d64b4"
import script from "./asignacionAGestores.vue?vue&type=script&lang=js"
export * from "./asignacionAGestores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports